module.exports = __webpack_public_path__ + "images/úsáideoirí-idirlín-domhanda.jpg";